import { Dispatch, SetStateAction, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useLocalStorage = <T = any>(key: string, initialValue?: T) => {
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch {
      // If error also return initialValue
      return initialValue;
    }
  });

  const setValue: Dispatch<SetStateAction<T>> = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;

      setStoredValue(valueToStore);

      localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch {
      // Do nothing.
      // We expect normally we could receive an exception when trying to set local storage when the user has disabled storage for the site.
    }
  };

  return [storedValue, setValue] as const;
};

export const clearLocalStorageByKey = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // Same here as setting a value. If the user disabled the storage for the site this might throw and we do nothing.
  }
};

export default useLocalStorage;
